import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 retrieve_grn_scheduler_list: { status: "idle" },
};

export const retrieve_grn_scheduler_list_Slice = createSlice({
 name: "retrieve_grn_scheduler_list",
 initialState,
 reducers: {
  success_retrieve_grn_scheduler_list: (state, action) => {
   state.retrieve_grn_scheduler_list = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_grn_scheduler_list: (state, action) => {
   state.retrieve_grn_scheduler_list = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_grn_scheduler_list: (state) => {
   state.retrieve_grn_scheduler_list = { status: app_consts.IDLE };
  },
  loading_retrieve_grn_scheduler_list: (state) => {
   state.retrieve_grn_scheduler_list = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_grn_scheduler_list, fail_retrieve_grn_scheduler_list, reset_retrieve_grn_scheduler_list, loading_retrieve_grn_scheduler_list } = retrieve_grn_scheduler_list_Slice.actions;

export default retrieve_grn_scheduler_list_Slice.reducer;